import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface dashboard { }

interface DashboardState {
  recent_orders: any;
  data: dashboard[];
  transactiondata: transactiondata[];
  loading: boolean;
  error: any;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

// Diet Mapping Code
interface DashboardParams {
  start_date: any;
  end_date: any;
  areaCodeId: number;
}
interface transactiondata {
  first_name: any;
  order_reference: string;
  total_amount: number;
  payment_mode: string;
  order_placed_at: string;
  payment_status: string;
  user_profile_id: number;
  user_name: string;
  order_transactions: any;
}

export const getAdminDashboard = createAsyncThunk<
  dashboard[], // return type
  DashboardParams, // param type (THIS FIXES YOUR ISSUE)
  { rejectValue: string } // reject type
>('dashboard/getAdminDashboard', async (params, { rejectWithValue }) => {
  try {
    const response = await apiService.post<{ data: dashboard[] }>(
      '/get_admin_dashboard',
      params,
      PORT,
      URL,
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
  }
});

export const getOrderTransactions = createAsyncThunk<
  transactiondata[],
  { startDate?: string; endDate?: string },
  { rejectValue: string }
>(
  'dashboard/getUserTransactions',
  async (params, { rejectWithValue }) => {
    try {
      const { startDate, endDate } = params || {};

      const query = new URLSearchParams();

      if (startDate) query.append('startDate', startDate);
      if (endDate) query.append('endDate', endDate);

      const response = await apiService.get<{
        data: {
          order_transactions: transactiondata[];
        };
      }>(`/get_order_transactions?${query.toString()}`, PORT, URL);

      return response.data.order_transactions;

    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'An error occurred'
      );
    }
  }
);

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: [],
    transactiondata: [],
    loading: false,
    error: null,
  } as unknown as DashboardState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminDashboard.fulfilled, (state, action: PayloadAction<dashboard[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAdminDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      })
      .addCase(getOrderTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getOrderTransactions.fulfilled,
        (state, action: PayloadAction<transactiondata[]>) => {
          state.loading = false;
          state.transactiondata = action.payload; // ✅ FIX
        },
      )
      .addCase(getOrderTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      });
  },
});

export default dashboardSlice.reducer;
